export default __webpack_public_path__ + "static/media/CABOTO-Regular.30301470.woff2";